import { BulkUploadErrors } from '../hooks/useHandleRejectedDocuments.ts';
import type { Doc } from '../hooks/useUploadReducer.ts';
import { DocErrors } from '../hooks/useUploadReducer.ts';

export const checkIsAllDocsNotLoaded = (
	docs: Doc[],
	setBulkError: (error: string) => void,
): void => {
	const notLoadedErrors = [
		DocErrors.REQUEST_ABORTED_ERROR,
		DocErrors.NOT_UNIQ_TITLE,
		DocErrors.FAILED_UPLOAD_ERROR,
		DocErrors.STRICT_FORMAT_ERROR,
		DocErrors.PAYLOAD_TOO_LARGE,
	];

	const notLoadedDocuments = docs.filter((doc) => {
		const errorType = doc.error?.type;
		return notLoadedErrors.includes(errorType as DocErrors);
	});

	if (notLoadedDocuments.length == docs.length) {
		setBulkError(BulkUploadErrors.ALL_REJECTED_ERROR);
		throw BulkUploadErrors.ALL_REJECTED_ERROR;
	}
};
